import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// ScrollTrigger Docs: https://greensock.com/docs/v3/Plugins/ScrollTrigger
(($) => {

    //global reveal triggers
    //When trigger class is 200px from the bottom in view toggle the "revealed" class
    //what happens when that class is added is up to the css
    const reveal = gsap.utils.toArray('.js-trigger-effect');
    reveal.forEach(reveal => {

        // Content Reveal Animation
        ScrollTrigger.create({
            start: "top bottom-=100px", //200px from the bottom
            trigger: reveal,
            onEnter: ({ progress, direction, isActive }) => reveal.classList.add('animated'),
            //onLeaveBack: ({progress, direction, isActive}) => reveal.classList.remove('animated'),
            //markers: {startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20}
        });

    });


    //circle movement - non header content rows, image content rows, case studies slideshow, single team member
    const circlemoveup1 = gsap.utils.toArray('.js-bgcircle-move-up1');
    circlemoveup1.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: '-30%'
        });

    });

    //circle movement - standard content default template
    const circlemoveup2 = gsap.utils.toArray('.js-bgcircle-move-up2');
    circlemoveup2.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: '0%'
        });

    });

    //circle movement for card listings (webinars, work, articles)
    const circlemiddlemove = gsap.utils.toArray('.js-bgcircle-move-listing');
    circlemiddlemove.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: '-100%'
        });

    });

    const circleservicemove = gsap.utils.toArray('.js-bgcircle-move-service');
    circleservicemove.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: '0%'
        });

    });

    //circle movement for header row
    const circleheadermove = gsap.utils.toArray('.js-bgcircle-header-move');
    circleheadermove.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom-=200px",
                end: "bottom top",
                scrub: true
            },
            y: '50%'
        });

    });


    //circle movement for default throughout placement
    const circledefault = gsap.utils.toArray('.js-bgcircle-move-default');
    circledefault.forEach(item => {

        let circle = item.querySelector('.bg-circle');

        gsap.to(circle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: '-10%'
        });

    });

    //circle movement for header row
    const brcircleheadermove = gsap.utils.toArray('.js-bgcircle-brheader-move');
    brcircleheadermove.forEach(item => {

        let brcircle = item.querySelector('.bg-circle');

        gsap.to(brcircle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom-=200px",
                end: "bottom top",
                scrub: true
            },
            y: '20%'
        });

    });

    //circle movement for default throughout placement
    const brcirclecontent = gsap.utils.toArray('.js-bgcircle-move-brcontent');
    brcirclecontent.forEach(item => {

        let brcircle = item.querySelector('.bg-circle');

        gsap.to(brcircle, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                //markers: { startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20 }
            },
            y: '-10%'
        });

    });

    let contactPattern = document.querySelector('.pattern--contact-v2');
    if( !!contactPattern ){
        // DOTS BACKGROUND MOVEMENT
        document.body.addEventListener("mousemove", function(e) {

            let $this = $(this);
            let relX = e.pageX - $this.offset().left;
            let relY = e.pageY - $this.offset().top;

            gsap.to('.svg-circle-1', {duration: 1,
                x: (relX - $this.width() / 2) / $this.width() * -20,
                y: (relY - $this.height() / 2) / $this.height() * 30
            });

            gsap.to('.svg-circle-2',{duration: 1,
                x: (relX - $this.width() / 2) / $this.width() * 50,
                y: (relY - $this.height() / 2) / $this.height() * 50
            });

            gsap.to('.svg-circle-4', {duration: 1,
                x: (relX - $this.width() / 2) / $this.width() * -40,
                y: (relY - $this.height() / 2) / $this.height() * -20
            });

            gsap.to('.svg-circle-3', {duration: 1,
                x: (relX - $this.width() / 2) / $this.width() * 30,
                y: (relY - $this.height() / 2) / $this.height() * -30
            });

            gsap.to('.svg-circle-5', {duration: 1,
                x: (relX - $this.width() / 2) / $this.width() * -40,
                y: (relY - $this.height() / 2) / $this.height() * 40
            });

        });
    }

})(jQuery)